export default function preloadAssets(scene) {

    scene.load.setBaseURL('./taydu_dangkytruoc/game/images');
    
    // Background 
    
    scene.load.image('world', 'world.jpg');

    // Tree

    scene.load.image('tree-1', 'tree/1.png');
    scene.load.image('tree-2', 'tree/2.png');
    scene.load.image('tree-3', 'tree/3.png');
    scene.load.image('tree-4', 'tree/4.png');
    scene.load.image('tree-5', 'tree/5.png');
    scene.load.image('tree-6', 'tree/6.png');

    // Dirt

    scene.load.image('dirt-1', 'dirt/1.png');
    scene.load.image('dirt-2', 'dirt/2.png');
    scene.load.image('dirt-3', 'dirt/3.png');
    scene.load.image('dirt-4', 'dirt/4.png');
    scene.load.image('dirt-5', 'dirt/5.png');

    // Cloud

    scene.load.image('cloud-1', 'cloud/1.png');
    scene.load.image('cloud-2', 'cloud/2.png');
    scene.load.image('cloud-3', 'cloud/3.png');

    // Hero 

    scene.load.image('hero-base', 'monkey_king.png');
    scene.load.image('hero-cloud', 'cloud.png');
    scene.load.image('hero-basket', 'basket.png'); 

    // Fruits basket

    scene.load.image('end-basket-1', 'basket-end-1.png');
    scene.load.image('end-basket-2', 'basket-end-2.png');

    // Peach

    scene.load.image('big-peach', 'peach/big.png');
    scene.load.image('big-peach-leaf', 'peach/big-leaf.png');
    scene.load.image('big-peach-fall-left', 'peach/big-fall-left.png');
    scene.load.image('big-peach-fall-right', 'peach/big-fall-right.png');

    scene.load.image('small-peach', 'peach/small.png');
    scene.load.image('small-peach-leaf', 'peach/small-leaf.png');
    scene.load.image('small-peach-fall-left', 'peach/small-fall-left.png');
    scene.load.image('small-peach-fall-right', 'peach/small-fall-right.png');


    scene.load.image('golden-peach', 'peach/golden.png');
    scene.load.image('golden-peach-leaf', 'peach/golden-leaf.png');
    scene.load.image('golden-peach-fall-left', 'peach/golden-fall-left.png');
    scene.load.image('golden-peach-fall-right', 'peach/golden-fall-right.png');

    //  UI

    scene.load.image('text-end', 'ui/text-end.png');
    scene.load.image('text-start', 'ui/text-start.png');

    scene.load.image('btn-start', 'ui/btn-start.png');
    scene.load.image('btn-restart', 'ui/btn-restart.png');
    scene.load.image('btn-finish', 'ui/btn-finish.png');
    scene.load.image('btn-finish-off', 'ui/btn-finish-off.png');
    scene.load.image('btn-fast', 'ui/btn-fast.png');
    scene.load.image('btn-slow', 'ui/btn-slow.png');
    scene.load.image('btn-pause', 'ui/btn-pause.png');
    scene.load.image('btn-resume', 'ui/btn-resume.png');

    // Process

    scene.load.image('process', 'ui/process.png');
    scene.load.image('process-act', 'ui/process-act.png');
    scene.load.image('process-icon', 'ui/process-icon.png');



}